let pendingRedirect = null;

export function normalizeAuthRedirect(path) {
  if (
    typeof path !== "string" ||
    !path.startsWith("/") ||
    path.startsWith("//") ||
    path.length > 2048 ||
    path.includes("\\") ||
    path.includes("#") ||
    /[\u0000-\u001f\u007f]/.test(path) ||
    /%(?:0a|0d)/i.test(path) ||
    /^\/%(?:2f|5c)/i.test(path)
  ) {
    return null;
  }
  return path;
}

export function rememberAuthRedirect(path) {
  pendingRedirect = normalizeAuthRedirect(path);
}

export function consumeAuthRedirect() {
  const redirect = pendingRedirect;
  pendingRedirect = null;
  return redirect;
}
